<template>
  <div>
    <a
      class="title"
      role="button"
      @click="toSong(song)"
    >
      <span>{{ truncate(song.title) }}</span>
    </a>
    <a
      v-if="authors.length > 0"
      role="button"
      class="artist"
      @click="toArtist(authors[0])"
    >
      <span class="icon is-small">
        <i class="mdi mdi-pencil" />
      </span>
      <span>{{ $truncate(authors[0].name) }} </span>
      <b-tooltip
        v-if="authors.length > 1"
        :label="authors.slice(1, authors.length).map(i => i.name).join(', ')"
        type="is-dark"
        multilined
        :position="position"
      >
        <span> (...)</span>
      </b-tooltip>
    </a>
    <a
      v-if="interprets.length > 0"
      role="button"
      class="artist"
      @click="toArtist(interprets[0])"
    >
      <span class="icon is-small">
        <i class="mdi mdi-microphone" />
      </span>
      <span>{{ $truncate(interprets[0].name) }} </span>
      <b-tooltip
        v-if="interprets.length > 1"
        :label="interprets.slice(1, interprets.length).map(i => i.name).join(', ')"
        type="is-dark"
        multilined
        :position="position"
      >
        <span> (...)</span>
      </b-tooltip>
    </a>
  </div>
</template>

<script>

import { toSong, toArtist } from "@/services/navigator.js";
import { truncate } from "lodash";

export default {
	props: {
		song: {
			required: true,
			type: Object
		},
		position: {
			default: "is-left"
		}
	},
	computed: {
		artist () {
			return this.$store.state.artists[this.$route.params.artist] || {};
		},
		authors () {
			let ids = this.song.author_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.author_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
		interprets () {
			let ids = this.song.interpret_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.interpret_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		}
	},
	methods: {
		truncate (str) {
			return truncate(str);
		},
		toSong (song) {
			toSong(song.id);
		},
		toArtist (artist) {
			toArtist(artist.id);
		}
	},
};
</script>

<style>
.icon.is-small {
    width: 0.7rem;
}
.icon.is-info {
    height: 1rem;
}
</style>

